exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listing-title[data-v-2056dc0f] {\n  display: inline;\n  margin: 0;\n  vertical-align: middle;\n}\n.asset-item[data-v-2056dc0f]:not(:last-of-type) {\n  padding-bottom: 10px;\n}\n", ""]);

// exports
